import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

/**
 * Skeleton placeholder for a catalog card, shown while the catalog list is loading
 * on initial load, search, or filter (NOT during infinite-scroll paging, which keeps
 * the spinner loader). Mirrors the `catalog-card` list/tile layout.
 * Figma: node 508-10616.
 */
@Component({
  selector: 'app-catalog-card-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './catalog-card-skeleton.component.html',
  styleUrls: ['./catalog-card-skeleton.component.scss'],
})
export class CatalogCardSkeletonComponent {
  /**
   * Layout variant — matches the sibling `catalog-card` variant so the skeleton
   * occupies the same footprint in list and grid views.
   */
  variant = input<'list' | 'tile'>('list');
}
